import { OrganizerSeatIcon as OrganizerSeatSvg } from '@app/components/icons/organizer-seat';
import React from 'react';

export const OrganizerSeatIcon = () => (
  <div className="flex size-9 shrink-0 items-center justify-center rounded-full bg-gray-50">
    <OrganizerSeatSvg width={16} height={16} className="text-primary" />
  </div>
);
